export const scrollTo = (idName) => {
  if (idName) {
    let anchorElement = document.getElementById(idName);
    if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
  }
}